import throttle from 'lodash/throttle'

//懒加载，滚动到底部后执行callback，只针对于可指定子元素类名，默认是本身元素
function inserted(el, binding) {
  // console.log('binding', binding)
  const callback = binding.value
  const targetEl = binding.arg
  let dom = targetEl ? el.querySelector(`.${targetEl}`) : el
  const throttledScroll = throttle(() => {
    const scrollDistance = dom.scrollHeight - dom.scrollTop - dom.clientHeight
    // console.log('scrollDistance', scrollDistance)
    if (scrollDistance <= 1) callback()
  }, 300)
  dom.addEventListener('scroll', throttledScroll, true)
}

export default {
  inserted
}
